<script lang="ts">
	import Section from "#lib/web-ui/primitives/section.svelte";

	import { getTemplateContext, cloudinaryUrl } from "../template-context.svelte";

	const asHeardOnVendors = $derived(getTemplateContext().asHeardOnVendors);
</script>

<Section>
	<div class="mb-8 text-center">
		<h2 class="text-foreground text-center text-lg/8 font-semibold">
			As Heard On & As Seen On
		</h2>
	</div>

	<div class="grid grid-cols-2 items-center gap-6 md:grid-cols-3 lg:grid-cols-5">
		{#each asHeardOnVendors as vendor}
			<div
				class="flex items-center justify-center p-4 transition-transform duration-200 hover:scale-105"
			>
				<img
					src={cloudinaryUrl(vendor.src, { width: 150 })}
					width="150"
					height="45"
					alt={vendor.alt}
					loading="eager"
					fetchpriority="high"
				/>
			</div>
		{/each}
	</div>
</Section>
